import { render, staticRenderFns } from "./Izgubljeno_nadjeno.vue?vue&type=template&id=b5f3d1a6&"
import script from "./Izgubljeno_nadjeno.vue?vue&type=script&lang=js&"
export * from "./Izgubljeno_nadjeno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports